import React from 'react';
import { useLocation } from 'react-router';
import {
  useSaveStoreSettings,
  useStoreSettings,
} from 'Settings/hooks/store/settings';
import CheckStoreInformationForm from '../Components/CheckStoreInformationForm'; // FormValues,

interface OwnProps {
  children?: React.ReactElement;
  onFinish?: () => void;
  goBack?: () => void;
}

const CheckStoreInformation: React.FC<OwnProps> = ({
  children,
  onFinish,
  goBack,
}) => {
  const { pathname } = useLocation();
  const fetchSettingsQuery = useStoreSettings(pathname);
  const saveSettingsMutation = useSaveStoreSettings(pathname);
  const handleSaveSettings = (values: any) => {
    const data = {
      ...values,
      shipping_address: {
        ...values.shipping_address,
        country: values.country,
      },
    };
    saveSettingsMutation.mutate(data, {
      onSuccess: () => {
        if (onFinish) onFinish();
      },
    });
  };
  return (
    <CheckStoreInformationForm
      settings={fetchSettingsQuery.data}
      saveSettings={handleSaveSettings}
      isDataLoading={fetchSettingsQuery.isLoading}
      showPrevious
      goBack={goBack}
    >
      <>
        {children} {/* for the infobox, if needed */}
      </>
    </CheckStoreInformationForm>
  );
};

export default CheckStoreInformation;
